import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#ffffff',
  },
  mark: {
    height: 38,
    width: 28,
    objectFit: 'contain',
  },
  wordmark: {
    height: 26,
    width: 48,
    objectFit: 'contain',
  },
  product: {
    borderLeft: '1px solid rgba(255, 255, 255, 0.35)',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.8,
    lineHeight: 1.2,
    paddingLeft: theme.spacing(1),
    textTransform: 'uppercase',
  },
}));

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root} aria-label="THiNK Engineering">
      <img className={classes.mark} src="/brand/think-mark-purple.png" alt="" />
      <img
        className={classes.wordmark}
        src="/brand/think-wordmark-white.png"
        alt="THiNK"
      />
      <span className={classes.product}>Engineering</span>
    </div>
  );
};
